import { render } from "./Conference.vue?vue&type=template&id=582ae4f5"
import script from "./Conference.vue?vue&type=script&lang=js"
export * from "./Conference.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__